module.exports = __webpack_public_path__ + "img/quality-price.f185273.png";